import React from "react";
import { Chip, styled, Typography } from "@mui/material";
import { chipColors } from "./constants";

const ConditionChips = (props) => {
    const { noWrap } = props;
    const { conditions } = props.rule;
    return (
        <React.Fragment>
            <Typography noWrap={noWrap}>
                {conditions.map((condition, i) => {
                    const { conditionValue, conditionType, conditionOperator } = condition;
                    const label = conditionOperator
                        ? `${conditionType.displayName} ${conditionOperator.displayName} ${conditionValue}`
                        : conditionType.displayName;
                    return (
                        <ChipStyle
                            variant="outlined"
                            key={i}
                            label={label}
                        />
                    );
                })}
            </Typography>
        </React.Fragment>
    );
};

const ChipStyle = styled(Chip)({
    marginRight: "5px",
    marginBottom: "5px",
    border: `0.2em solid ${chipColors.hidden}`
});

export default ConditionChips;
